// trackEvent.js
'use strict';
import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import getMeData from '../selector/getMeData.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';
import {
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Track event
 * @kind action
 * @param {string} {event} - event name.
 * @param {object} {properties} - event properties.
 * @return {Promise} Action promise.
 */
const trackEvent =
  ({ event, properties }) =>
  async (dispatch, getState) => {
    const selectPath = ['track', event];
    const token = getMeData(getState(), 'token');

    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        event,
        properties,
      }),
    };

    if (token) {
      fetchOptions.headers.Authorization = `Bearer ${token}`;
    }

    const url = getResourceUrl({ endpoint: '/track' });

    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath },
    });
    try {
      const response = await fetch(url.href, fetchOptions);

      if (!response.ok) {
        await handleFetchError({ response });
      }

      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default trackEvent;
